<!-- 运费表 -->
<template>
    <div class="container">
        <div class="searchFlex">
            <!-- 搜索框 -->
            <el-form size="mini" ref="searchform" :model="searchForm" label-width="90px" :inline="true"
                class="demo-form-inline">
                <el-form-item label="运费名称" style="margin-bottom: 0px">
                    <el-input v-model="searchForm.templateName" placeholder="请输入运费名称"></el-input>
                </el-form-item>
            </el-form>
            <div class="toolbar">
                <div class="toolbar-left">
                    <el-button type="success" size="mini" @click="getTable">查询</el-button>
                    <el-button type="primary" size="mini" @click="addFreight('add')">新建运费表</el-button>
                </div>
                <!-- <el-button type="info" size="mini">删除任务</el-button> -->
                <vxe-toolbar ref="toolbarRef" custom> </vxe-toolbar>
            </div>
        </div>
        <div style="width: 100%;height:calc(100vh - 145px);overflow-x: auto;">
            <vxe-table id="freightTable" :data="freightList" border :column-config="{ resizable: true }" align="center" size="mini"
                header-align="center" :columns="columns" stripe width="100%" height="100%" :custom-config="customConfig"
                ref="freightTableRef">
                <vxe-column v-for="(column, index) in columns" :field="column.field" :title="column.title">
                    <template #default="{ row, column }">
                        <span v-if="column.field === 'templateName'" @click="editEvent('edit',row)"><el-link  type="primary" target="_blank">{{ row[column.field] }}</el-link>  </span>
                        <span v-else> {{ row[column.field] }} </span>
                    </template>
                </vxe-column>
                <vxe-column title="操作" width="150">
                    <!-- <vxe-column title="操作" width="150" align="left"> -->
                    <template #default="{ row }">
                        <vxe-button mode="text" status="info" icon="vxe-icon-edit"
                            @click="editEvent('edit',row)">编辑</vxe-button>
                    </template>
                </vxe-column>
            </vxe-table>
        </div>
        <!-- 编辑新增弹出框 -->
        <el-dialog v-dialogDrag :title="dialogCode === 'add' ? '新增运费方案' : (dialogCode === 'edit'? '编辑运费方案' :'查看运费方案')" :fullscreen="true" :visible.sync="dialogShow"
            @close="handleClose('freightForm')">
            <div>
                <el-form ref="freightForm" :model="freightForm" label-width="120px" :inline="true"
                    class="demo-form-inline" :rules="freightRules">
                    <!-- <div class="title">费用方案</div> -->
                    <el-form-item label="费用方案名称" prop="templateName">
                        <el-input v-model="freightForm.templateName" ></el-input>
                    </el-form-item>
                    <el-form-item label="备注" prop="note">
                        <el-input v-model="freightForm.note" style="width: 600px;" ></el-input>
                    </el-form-item>
                </el-form>
                <!-- <div class="title">费用明细</div> -->
                <el-button type="primary" plain @click="addDetails" size="small">添加费用明细</el-button>
                <el-button type="primary" plain @click="save('freightForm')" size="small">保存</el-button>
                <el-table :data="detailsTable" :empty-text="'没有数据'" style="width:45%;min-width: 800px;" size="mini" height="calc(100vh - 220px)">
                    <el-table-column prop="startPort" label="起始地" width="160" align="center" >
                        <template slot-scope="scope">
                            <el-select size="small" filterable clearable v-model="scope.row.startPort" style="width: 100%"
                                placeholder="请选择起始地">
                                <el-option v-for="item in portList" :key="item.id" :label="item.value"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="endPort" label="目的地" width="160" align="center">
                        <template slot-scope="scope">
                            <el-select size="small" filterable clearable v-model="scope.row.endPort" style="width: 100%"
                                placeholder="请选择目的地">
                                <el-option v-for="item in portList" :key="item.id" :label="item.value"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="amount" label="金额" width="160" align="center">
                        <template slot-scope="scope">
                            <el-input size="small" onkeyup="value=value.match(/\d+\.?\d{0,2}/,'')" clearable style="width: 100%"
                                v-model="scope.row.amount" placeholder="请输入金额" ></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="taskType" label="任务类型" width="200" align="center">
                        <template slot-scope="scope">
                            <el-select size="small" filterable clearable v-model="scope.row.taskType" style="width: 100%"
                                placeholder="请选择任务类型">
                                <el-option v-for="item in taskTypeList" :key="item.label" :label="item.label" :value="item.label">
                                </el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column label=" 操作 " align="center" width="auto">
                        <template slot-scope="scope">
                            <!-- <el-button v-if="!scope.row.editing" @click="editDetails(scope.row,scope.$index)" type="text"
                                size="small">
                                编辑
                            </el-button>
                            <el-button v-if="scope.row.editing" @click="saveDetails(scope.row,scope.$index)" type="text" size="small">
                                保存
                            </el-button>
                            <el-button v-if="scope.row.editing" @click="cancel(scope.row,scope.$index)" type="text" size="small">
                                取消
                            </el-button> -->
                            <el-button v-if="!scope.row.editing" @click="deleteDetails(scope.row,scope.$index)" type="text"
                                size="small" style="margin-left: 10px">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import userProfile from '@/mixins/userProfile.js'
import basicData from '@/config/basicData.js'

export default {
    name: "taskList",
    mixins: [userProfile],
    components: {
    },
    data() {
        return {
            searchForm: {  //    查询条件
                templateName: '',
            },
            freightList: [], // 任务列表
            dialogCode: '',
            dialogShow: false,
            freightForm: { // 弹框编辑新增表单
                
            },
            detailsTable: [], // 编辑弹窗明细表格
            // olddetailsTable: [], // 旧弹窗明细表格 -- 用于取消
            columns:[], // 表格头
            // 站点列表
            portList: [],
            // 任务类型
            taskTypeList: basicData.taskType,
            // 添加运费方案必填
            freightRules:{
                templateName: [
                    { required: true, message: '请输入费用方案名称', trigger: 'blur' },
                ],
                note: [
                    { required: true, message: '请输入备注', trigger: 'blur' },
                ]
            }
        }
    },

    mounted() {
        this.getTable()
        this.getPort()
    },
    methods: {
        // 获取表格信息
        getTable() {
            this.$api.getTemplate( {templateName:this.searchForm.templateName } ).then(res =>{
                this.columns = res.columns;
                this.freightList = res.tableData;
            })
        },
        // 查询站点
        getPort() {
            this.$api.getDicList( { value:'陆运站点'} ).then(res =>{
                this.portList = res
            })
        },
        // 新建运费表
        addFreight(){
            this.dialogShow = true;
            this.dialogCode = 'add';
        },
        // 关闭弹窗
        handleClose(formName){
            this.freightForm = {}
            this.detailsTable = []
            this.dialogShow = false;
            // this.freightForm = {}
            this.$refs[formName].resetFields();
        },
        // 编辑费用方案，先查详情
        editEvent(code,data) {
            this.freightForm = data;
            // 查询详情
            this.$api.getTemplateDetailById( data.id ).then(res =>{
                this.detailsTable = res;
            })
            this.dialogShow = true;
            this.dialogCode = code;

        },
        // 删除详细方案 调用接口
        deleteDetails(data,index) {
            this.$confirm('是否确认删除该明细?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if(data.id){
                    // 有id调用接口,并删除数组
                    this.$api.deleteOneRecord( data.id ).then(res =>{
                        this.$message({
                            type: "success",
                            message: '删除成功'
                        });
                    })
                }else{
                    this.$message({
                        type: "success",
                        message: '删除成功'
                    });
                }
                this.detailsTable.splice(index, 1)
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        // 添加运费方案
        addDetails(){
            const details = {
                startPort: "",
                endPort: "",
                amount: null,
                taskType:"",
            }
            this.detailsTable.push(details)
        },
        // 弹窗保存
        save(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // 循环判断起始地\目的地\金额是否为空
                    for(let i = 0; i < this.detailsTable.length; i++){
                        if(this.detailsTable[i].startPort === "" || this.detailsTable[i].endPort === "" || this.detailsTable[i].amount === null || this.detailsTable[i].taskType === ""){
                            this.$message('请填写完整起始地,目的地,运费,任务类型');
                            return
                        }
                    }
                    const params = {
                        templateHead:{
                            id: this.freightForm.id, 
                            templateName: this.freightForm.templateName,
                            feeType: this.freightForm.feeType,
                            note: this.freightForm.note,
                        },
                        detailList: this.detailsTable
                    }
                    this.$api.saveOrUpdateTemplate( params ).then(res =>{
                        this.$message({
                                type: "success",
                                message: '保存成功'
                            });
                            this.handleClose('freightForm')
                            this.getTable()
                    })
                } else {
                    return false;
                }
                });
            
        }
    }
}
</script>
<style lang="css" scoped>
.container {
    width: 100%;
    height: calc(100vh - 84px);
    background-color: rgb(255, 255, 255);
    /* display: flex;
    flex-direction: column; */
}

.searchFlex {
    /* padding-top: 10px; */
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.toolbar {
    margin-right: 10px;
    /* width: 440px; */
    display: flex;
    justify-content: space-between;
}

.toolbar-left {
    display: flex;
    align-items: center;
    margin-right: 10px;
}
::v-deep .el-dialog__body {
    padding-top: 10px !important;
}
::v-deep .el-dialog__headerbtn {
    font-size: 24px !important;
}
</style>